import type { AllRouteEndpoints } from "../routeTypes";
export const appsConnectedContentCredentialEditCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/connected_content_credentials",
];
